/**
 * 组件信息
 */
export const info = {
  name: 'xy-vertical-layout', // 组件名
  type: 'component-container', // 组件类型
  label: '垂直布局', // 组件label
  icon: 'icon-xy-vertical-layout', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 400 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  scroll: { type: Boolean, default: false },
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: null,
      // 事件
      events: []
    })
  },
  language: {
    type: String,
    default: 'en'
  },
  listIndex: {
    type: Object,
    default: null
  },
  listItemData: {
    type: [Object, Array, String, Number, Boolean],
    default: undefined
  },
  pullup: {
    type: Boolean,
    default: false
  },
  pullupSource: {
    type: [Object, String],
    default: null
  },
  /** 上拉加载 — 关联组件及事件 */
  pullupConfig: {
    type: Object,
    default: () => ({
      componentUUID: '',
      funcName: ''
    })
  }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-switch', // 表单组件
    label: '是否滚动', // 表单名称
    propKey: 'scroll' // 表单model字段名称
  },
  {
    type: 'xy-form-switch', // 表单组件
    label: '上拉加载', // 表单名称
    propKey: 'pullup' // 表单model字段名称
  },
  {
    type: 'xy-form-data-source-cascader', // 表单组件
    label: '数据源', // 表单名称
    propKey: 'pullupSource' // 表单model字段名称
  },
  {
    type: 'xy-form-vertical-layout-pullup',
    propKey: 'pullupConfig'
  }
]
